
import { Component, Prop, Vue } from "vue-property-decorator";
import { UFliterals } from "@/utils/literals";
import { ISetting } from "@/schemas/ISetting";

@Component({
  name: "Debriefing",
})
export default class Debriefing extends Vue {
  @Prop({ required: true, type: String })
  readonly id!: string;

  sequence: any = null;
  selectedSettingId: string | null = null;
  currentSlide = 0;

  created(): void {
    this.$store.dispatch("sequence/fetchFullById", {
      id: this.id,
      next: (seq: any) => {
        this.sequence = seq;
      },
    });
  }

  mounted(): void {
    window.addEventListener("keydown", this.handleKeydown);
  }

  beforeDestroy(): void {
    window.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event: KeyboardEvent): void {
    if (event.key === "ArrowRight" || event.key === " ") {
      this.nextSlide();
    } else if (event.key === "ArrowLeft") {
      this.prevSlide();
    }
  }

  get selectedSetting(): ISetting | null {
    if (!this.sequence?.settings || !this.selectedSettingId) return null;
    return (
      this.sequence.settings.find(
        (s: ISetting) => s.id === this.selectedSettingId,
      ) || null
    );
  }

  get settingOptions(): any[] {
    if (!this.sequence?.settings) return [];
    return this.sequence.settings
      .filter((setting: ISetting) => setting.opened_at)
      .map((setting: ISetting) => ({
        id: setting.id,
        title: `${setting.activity?.title || "Activité sans titre"} - ${this.formatDateShort(setting.opened_at!)}`,
      }));
  }

  formatDateShort(dateStr: string): string {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  get statusInfo(): { label: string; color: string } {
    if (!this.selectedSetting) return { label: "", color: "grey" };
    return this.getSettingStatus(this.selectedSetting);
  }

  getSettingStatus(setting: ISetting): { label: string; color: string } {
    if (!setting.opened_at) {
      return { label: "Pas ouverte", color: "grey" };
    }
    if (setting.closed_at) {
      return { label: "Terminée", color: "success" };
    }
    return { label: "En cours", color: "info" };
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  getUF(key: string): string {
    return UFliterals[key] || "";
  }

  prevSlide(): void {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  nextSlide(): void {
    if (this.currentSlide < 2) {
      this.currentSlide++;
    }
  }
}
